/**
 * Helper para upload de fotos al backend.
 *
 * Flujo de 3 pasos:
 * 1. POST .../fotos con { content_type, caption } → recibe upload_url + s3_key.
 * 2. PUT a la upload_url con el File (a S3 directo, sin Axios, sin auth).
 * 3. POST .../fotos/confirmar con { s3_key, caption } → recibe el análisis actualizado.
 *
 * NOTA: Para el paso 2 se usa fetch directo (no Axios) porque la presigned URL
 * de S3 NO debe llevar el header Authorization de Cognito ni Content-Type JSON.
 */
export async function uploadToS3(uploadUrl: string, file: File): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });

  if (!response.ok) {
    throw new Error(`Upload to S3 failed with status ${response.status}`);
  }
}

export const ALLOWED_PHOTO_CONTENT_TYPES = ['image/jpeg', 'image/png'] as const;
export type AllowedPhotoContentType = (typeof ALLOWED_PHOTO_CONTENT_TYPES)[number];

export function isAllowedPhotoContentType(
  contentType: string
): contentType is AllowedPhotoContentType {
  return ALLOWED_PHOTO_CONTENT_TYPES.includes(contentType as AllowedPhotoContentType);
}

export function assertAllowedPhotoFile(file: File): void {
  if (!isAllowedPhotoContentType(file.type)) {
    throw new Error(
      `Tipo de archivo no permitido: ${file.type}. ` +
        `Solo se aceptan: ${ALLOWED_PHOTO_CONTENT_TYPES.join(', ')}.`
    );
  }
}
